<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll>
          <v-toolbar-title
            >Seguimiento del Presupuesto de Marketing</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-show="false"
                class="mx-2"
                icon
                large
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> download </v-icon>
                <download-excel
                  class="btn btn-default"
                  :data="vistas"
                  worksheet="Hoja 1"
                  :name="
                    'Reporte ' +
                    new Date().getFullYear() +
                    (new Date().getMonth() + 1) +
                    new Date().getDate() +
                    ' ' +
                    new Date().getHours() +
                    new Date().getMinutes() +
                    new Date().getSeconds()
                  "
                >
                  .
                </download-excel>
              </v-btn>
            </template>
            <span>Descarga de Archivo Excel</span>
          </v-tooltip>
          <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-show="false"
                class="mx-2"
                icon
                large
                color="primary"
                @click="mostrarDialogVista()"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> pivot_table_chart </v-icon>
              </v-btn>
            </template>
            <span>Ver Presupuesto anual</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-show="false"
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> file_upload </v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>
          <div v-if="!(id_presupuesto===1 || id_presupuesto===2 || id_presupuesto===3 )">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="addItem"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="true"

              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Ingresar nuevo registro</span>
          </v-tooltip>
          
          <v-tooltip bottom v-if="multiple">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarDialogDuplicar"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> fa-solid fa-clone </v-icon>
              </v-btn>
            </template>
            <span>Copiar a la siguiente gestión</span>
          </v-tooltip>
          <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="multiple=!multiple"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark>{{ multiple?'fa-solid fa-list':'fa-solid fa-list-check'}}</v-icon>
              </v-btn>
            </template>
            <span>{{ multiple?'Editar registros individuales':'Seleccionar varios registros' }}</span>
          </v-tooltip>
        </div>
        </v-app-bar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-autocomplete
                outlined
                dense
                ref="id_presupuesto"
                v-model="id_presupuesto"
                @change="listar"
                :items="presupuestos"
                :rules="[rules.requerido]"
                :error-messages="errorMessages"
                item-text="descripcion"
                item-value="id"
                label="Presupuesto"
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda General"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              

              <v-autocomplete
                  dense
                  outlined
                  class="text-xs-center"
                  v-model="searchCuentaValue"
                  :items="presupuesto_lineas"
                  append-icon="search"
                  label="Búsqueda por Cuenta"
                  item-text="cuenta_contable"
                  item-value="cuenta_contable"
                  clearable
                  hide-details
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-autocomplete
                outlined
                dense
                v-model="searchMesValue"
                @change="obtenerTotalPresupuestoPorMes(searchMesValue);"
                :items="meses"
                append-icon="search"
                label="Búsqueda por mes"
                item-text="descripcion"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-sheet class="overflow-y-auto" :max-height="windowHeigth - 200">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - 365"
            :headers="multiple?headers.filter(h => h.value !== 'opciones'):headers"
            :items="presupuesto_lineas"
            :items-per-page="2"
            :search="search"
            v-model="selectLineaPresupuesto"
            :show-select="multiple"
            sort-by="mes"
            class="elevation-1"
            show-group-by
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'group-text': 'Agrupar',
              'items-per-page-options': [50, 100, 150, -1],
            }"
          >
          <template #item.selected="{ item }">
                              
                                <v-checkbox v-model="item.selected"></v-checkbox>
                              
                              
                            </template>

            <template v-slot:[`item.opciones`]="{ item }">
              <div v-if="!(id_presupuesto===1 || id_presupuesto===2 || id_presupuesto===3) " >
              
              <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small text dark color="primary" @click="editItem(item)"  v-bind="attrs" v-on="on">
                  <v-icon x-small>fa-soli fa-pen</v-icon>
                </v-btn>
              </template>
              <span>Editar Línea</span>
            </v-tooltip>
             <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small text dark color="primary" @click="mostrarDialogDuplicar(item)" v-bind="attrs" v-on="on">
                  <v-icon x-small>fa-solid fa-clone</v-icon>
                </v-btn>
              </template>
              <span>Copiar a la siguiente gestión</span>
            </v-tooltip>
              
            
              
          </div>
              



              
            </template>

            <template v-slot:[`item.mes`]="{ item }">
              <div>
                {{ item.mes === null ? "" : enteroaMeses(item.mes, true) }}
              </div>
            </template>
            <template v-slot:[`item.monto`]="{ item }">
              <div>
                {{ $formatoNumero(item.monto) }}
              </div>
            </template>

            <template v-slot:footer>
              <v-row class="justify-end">
                <!-- Primera columna con los totales actuales -->
                <v-col cols="6" class="text-right">
                  <div class="font-weight-bold black--text">
                    Total Presupuesto Bs.: {{ $formatoNumero(totalPresupuesto) }}
                  </div>
                  <div class="font-weight-bold info--text">
                    Total seguimiento Bs.: {{ $formatoNumero(totalMonto) }}
                  </div>
                  <div :class="(totalPresupuesto - totalMonto) < 0 ? 'font-weight-bold error--text' : 'font-weight-bold success--text'">
                    Saldo Bs.: {{ $formatoNumero(totalPresupuesto - totalMonto) }}
                  </div>
                </v-col>

                <!-- Segunda columna con el total por mes -->
                <v-col cols="3" class="text-right" v-show="searchMesValue">
                  <div class="font-weight-bold black--text">
                    Presupuesto {{ enteroaMeses(searchMesValue) }} Bs.: {{ $formatoNumero(totalPresupuestoMes) }}
                  </div>
                  <div class="font-weight-bold info--text">
                    Seguimiento {{ enteroaMeses(searchMesValue) }}  Bs.: {{ $formatoNumero(totalMontoMes) }}
                  </div>
                  <div :class="(totalPresupuestoMes - totalMontoMes) < 0 ? 'font-weight-bold error--text' : 'font-weight-bold success--text'">
                    Saldo {{ enteroaMeses(searchMesValue) }} Bs.: {{ $formatoNumero(totalPresupuestoMes - totalMontoMes) }}
                  </div>
                </v-col>
              </v-row>
            </template>

  

            <template v-slot:no-data>
                  No hay información disponible
                </template>
          </v-data-table>
        </v-sheet>
      </v-card>

      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogTablaVista" persistent max-width="100%">
        <v-card>
          <v-card-title class="headline">Presupuesto por Año</v-card-title>
          <v-card-text>
            <v-data-table
              dense
              :headers="headersVista"
              :items="vistas"
              :items-per-page="2"
              :search="search"
              sort-by="producto"
              class="elevation-1"
              show-group-by
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'group-text': 'Agrupar',
                'items-per-page-options': [50, 100, 150, -1],
              }"
            >
              <template v-slot:[`item.opciones`]="{ item }">
                <v-btn
                  x-small
                  text
                  dark
                  color="primary"
                  @click="editItem(item)"
                >
                  <v-icon x-small>edit</v-icon>
                </v-btn>
              </template>

              <template v-slot:no-data>
                <span>No hay elementos para mostrar</span>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text @click="dialogTablaVista = false">
              <download-excel
                class="btn btn-default"
                :data="vistas"
                worksheet="Hoja 1"
                :name="
                  'Reporte ' +
                  new Date().getFullYear() +
                  (new Date().getMonth() + 1) +
                  new Date().getDate() +
                  ' ' +
                  new Date().getHours() +
                  new Date().getMinutes() +
                  new Date().getSeconds()
                "
              >
                Exportar a Excel
              </download-excel>
            </v-btn>
            <v-btn text @click="dialogTablaVista = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
                v-model="dialog"
                persistent
                :max-width="windowWidth < 1000 ? '100%' : '50%'"
              >
                <v-card ref="form">
                  <v-app-bar color="white" elevate-on-scroll>
                    <v-toolbar-title class="font-weight-black primary--text">{{
                      formTitle
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div v-show="!mensajeError">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-2"
                            icon
                            large
                            color="primary"
                            @click="guardar()"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!presupSelect"
                          >
                            <v-icon dark> save </v-icon>
                          </v-btn>
                        </template>
                        <span>Guardar Registro(s)</span>
                      </v-tooltip>
                    </div>
                    <div v-show="mensajeError">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            large
                            @click="mostrarDialogReemplazar"
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!presupSelect"
                          >
                            <v-icon dark> save_as </v-icon>
                          </v-btn>
                        </template>
                        <span>Guardar y Reemplazar</span>
                      </v-tooltip>
                    </div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="close"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!presupSelect"
                        >
                          <v-icon dark> close </v-icon>
                        </v-btn>
                      </template>
                      <span>Cerrar</span>
                    </v-tooltip>
                  </v-app-bar>
                  <v-card-text>
                    <v-container>
                      <div v-show="mensajeError">
                        <v-alert
                          text
                          dense
                          color="error"
                          icon="warning"
                          border="left"
                        >
                          <v-row align="center">
                            <v-col class="grow">
                              Algunos registros ya fueron realizados.
                            </v-col>
                            <v-col class="shrink">
                              <v-btn
                                x-small
                                color="error"
                                @click="snackbar = true"
                                >Detalles</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-alert>
                      </div>

                      <v-snackbar
                        v-model="snackbar"
                        :multi-line="true"
                        color="error"
                      >
                        <pre>{{ error }}</pre>

                        <template v-slot:action="{ attrs }">
                          <v-btn
                            color="white"
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                          >
                            Close
                          </v-btn>
                        </template>
                      </v-snackbar>

                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete
                            outlined
                            dense
                            ref="id_cuenta_contable"
                            v-model="id_cuenta_contable"
                            :items="cuentasContables"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Cuenta Contable"
                            required
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete
                            outlined
                            dense
                            v-role-disable="['COM', 'ADM']"
                            ref="id_centro_costo"
                            v-model="id_centro_costo"
                            :items="centroCostos"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Centro de Costo"
                            required
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete
                            outlined
                            dense
                            v-role-disable="['COM', 'ADM']"
                           
                            ref="id_servicio"
                            v-model="id_servicio"
                            :items="servicios"
                            :rules="[]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Servicio/Medio de Comunicación"
                            :search-input.sync="nuevoServicio"
                            required
                          >
                            <template v-slot:no-data>
                              <div
                                v-if="
                                  nuevoServicio == null || nuevoServicio == ''
                                "
                              >
                                <p>No hay información disponible</p>
                              </div>
                              <div v-else>
                                <v-btn
                                  plain
                                  tile
                                  color="primary"
                                  @click="abrirAgregarServicio()"
                                >
                                  <v-icon left> add </v-icon>
                                  Agregar Servicio
                                </v-btn>
                              </div>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete
                            outlined
                            dense
                            v-role-disable="['COM', 'ADM']"
                            ref="id_tipo_aprobacion"
                            v-model="id_tipo_aprobacion"
                            :items="tipoAprobaciones"
                            :rules="[]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Aprobación"
                            required
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            outlined
                            dense
                            chips
                            deletable-chips
                            multiple
                            ref="id_familia"
                            v-model="id_familia"
                            @change="validarDuplicados"
                            :readonly="editedIndex"
                            :items="familias"
                            :rules="[rules.requerido2]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Familia"
                            required
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-textarea
                outlined
                dense
                ref="detalle"
                v-model="detalle"
                :rules="[rules.requerido]"
                
                :error-messages="errorMessages"
                label="Detalle"
                placeholder="Detalle"
                required
              ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete
                            outlined
                            dense
                            ref="mes"
                            v-model="mes"
                            @change="validarDuplicados"                            
                            :items="meses"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Mes"
                            required
                          ></v-autocomplete>

                       
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field
                            outlined
                            dense
                            reverse
                            ref="monto"
                            v-model="monto"
                            @change="validarDuplicados"
                            @keydown="validarDuplicados"
                            :rules="[
                              rules.requerido,
                              rules.numero,
                              rules.mayorCero,
                            ]"
                            :error-messages="errorMessages"
                            label="Monto(Bs.)"
                            placeholder="Monto(Bs.)"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogReemplazar" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text
                    >Esta acción reemplazará los registros realizados
                    anteriormente según el detalle mostrado en el mensaje de
                    alerta. ¿Desea continuar?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogReemplazar = false"
                      >Cancelar</v-btn
                    >
                    <v-btn color="primary" text @click="guardarReemplazar()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogAgregarServicio" max-width="500px">
                <v-card ref="form">
                  <v-card-title>
                    <span class="headline">Agregar Servicio</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            dense
                            ref="codigoServicio"
                            v-model="codigoServicio"
                            :rules="[rules.requerido, rules.max10, rules.min2]"
                            :error-messages="errorMessages"
                            label="Código"
                            placeholder="Código"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            dense
                            ref="descripcionServicio"
                            v-model="descripcionServicio"
                            :rules="[rules.requerido, rules.max50, rules.min2]"
                            :error-messages="errorMessages"
                            label="Descripción"
                            placeholder="Descripción"
                            required
                          ></v-text-field>

                          <v-autocomplete
                            outlined
                            dense
                            ref="id_nitServicio"
                            v-model="id_nitServicio"
                            :items="nitsServicio"
                            :rules="[]"
                            label="Nit Facturación"
                            item-text="descripcion"
                            item-value="id"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeServicio"
                      >Cancelar</v-btn
                    >
                    <v-btn color="primary" text @click="guardarServicio"
                      >Guardar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogBorrar" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text v-if="multiple">
                    Esta acción borrará las líneas seleccionadas, y ya no figurarán
                    en el presupuesto. ¿Desea continuar?</v-card-text
                  >
                  <v-card-text v-else
                    >Esta acción borrará la línea seleccionada, y ya no figurará
                    en el presupuesto. ¿Desea continuar?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogBorrar = false">Cancelar</v-btn>
                    <v-btn color="primary" text @click="multiple?borrarItems():borrarItem()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDuplicar" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text v-if="multiple">
                    Esta acción duplicará las líneas seleccionadas, y figurarán
                    en el presupuesto de la siguiente gestión en el mismo mes o meses. ¿Desea continuar?
                    </v-card-text>
                    <v-card-text v-else>
                    Esta acción duplicará la línea seleccionada, y figurará
                    en el presupuesto de la siguiente gestión en el mismo mes. ¿Desea continuar?
                    </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :v-show="loader" text @click="dialogDuplicar = false">Cancelar</v-btn>
                    <v-btn :loading="loader" color="primary" text @click="multiple?duplicarItems():duplicarItem()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import Servicio from "./Servicio.vue";

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeigth: window.innerHeight,
      presupuesto_lineas: [],
      totalPresupuesto: 0,
      totalPresupuestoMes: 0,
      presupuestos: [],
      familias: [],
      servicios: [],
      cuentasContables: [],
      nitsServicio: [],
      centroCostos: [],
      tipoAprobaciones: [],
      itemPresupuestoLinea: {},
      vistas: [],
      meses: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
      ],
      dialog: false,
      dialogUpload: false,
      dialogReplicar: false,
      dialogReemplazar: false,
      dialogBorrar: false,
      dialogDuplicar: false,
      dialogTablaVista: false,
      presupSelect: false,
      mensajeError: false,
      multiple: false,
      selectLineaPresupuesto: [],
      usuario: this.$store.state.usuario.user,
      codigoSac: this.$store.state.usuario.codigoSac,
      page: 1,
      itemsPerPage: 12,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          groupable: false,
          sortable: false,
          width: "10%",
          
          align: this.multiple? " d-none":"center",
          class: "primary white--text text-subtitle-2",
          
        },
        {
          text: "Cuenta Contable",
          value: "cuenta_contable",
          align: "left",
          filter: this.filtroCuenta,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro Costo",
          value: "centro_costo",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mes",
          value: "mes",
          align: "left",
          filter: this.filtroMes,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Servicio",
          value: "servicio",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Familia",
          value: "familia",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Tipo de Aprobación",
          value: "tipo_aprobacion",
          align: "left",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Detalle",
          value: "detalle",
          align: "left",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Monto (Bs.)",
          value: "monto",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersVista: [
        {
          text: "Cuenta Contable",
          value: "desc_cuc",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro Costo",
          value: "desc_cco",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Servicio",
          value: "desc_serv",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Producto",
          value: "desc_fam",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Enero",
          value: "enero",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Febrero",
          value: "febrero",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Marzo",
          value: "marzo",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Abril",
          value: "abril",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mayo",
          value: "mayo",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Junio",
          value: "junio",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Julio",
          value: "julio",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Agosto",
          value: "agosto",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Septiembre",
          value: "septiembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Octubre",
          value: "octubre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Noviembre",
          value: "noviembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Diciembre",
          value: "diciembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Total",
          value: "total",
          align: "center",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        requerido2: (value) => !!value[0] || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        mayorCero: (value) => value > 0.01 || "Ingrese una monto superior.",
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchCuentaValue: "",
      searchMesValue: "",

      editedIndex: false,
      editCodigo: false,
      mostrarErrores: false,

      id: "",
      dialogAgregarServicio: false,
      id_presupuesto: "",
      nuevoServicio: "",
      id_cuenta_contable: "",
      id_centro_costo: "",
      codigoServicio: "",
      descripcionServicio: "",
      id_nitServicio: "",

      tipo_presupuesto: "COM",
      mes: "",
      monto: "0",
      id_servicio: "",
      id_familia: [],
      id_tipo_aprobacion: "",
      detalle: "",
      snackbar: "",
      loader: false,

      nombreExcel:
        "Reporte " +
        new Date().getFullYear() +
        (new Date().getMonth() + 1) +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds(),

      file: null,

      valida: 0,

      validaMensaje: [],

      adCodigo: "",
      errorMessages: "",
      error: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === false
        ? "Nuevo Registro"
        : "Actualizar Registro";
    },

    form() {
      return {
        id_cuenta_contable: this.id_cuenta_contable,
        id_centro_costo: this.id_centro_costo,
        mes: this.mes,
        monto: this.monto,
        id_servicio: this.id_servicio,
        id_familia: this.id_familia,
        detalle: this.detalle,
        id_tipo_aprobacion: this.id_tipo_aprobacion,
      };
    },
    formServicio() {
      return {
        codigoServicio: this.codigoServicio,
        descripcionServicio: this.descripcionServicio,
        id_nitServicio: this.id_nitServicio,
      };
    },
    totalMonto() {
      return this.presupuesto_lineas.reduce((acc, item) => acc + (item.monto || 0), 0);
    },
    totalMontoMes() {
      return this.presupuesto_lineas
        .filter(item => 
          !Number.isInteger(this.searchMesValue) || this.searchMesValue <= 0 || item.mes === this.searchMesValue
        )
        .reduce((acc, item) => acc + (item.monto || 0), 0);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
    },
    nuevoTipo(val) {},
  },

  created() {
    console.log("created",this.$store.state.usuario);
    this.selectPresupuesto();
    this.selectCuentasContables();
    this.selectCentroCostos();
    this.selectFamilia();
    this.selectServicio();
    this.selectAprobacion();
    this.selectNits();
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },

    closeServicio() {
      this.dialogAgregarServicio = false;
      this.limpiarServicio();
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/presupuesto_lineas/cargarExcel", formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/seguimiento_lineas/ListarSeguimientoCom/" + me.id_presupuesto+"/"+ me.codigoSac)
        .then(function (response) {
          me.presupuesto_lineas = response.data;
          console.log("listar",me.presupuesto_lineas);
          me.selectLineaPresupuesto = [];
          me.presupSelect = true;
          me.windowWidth = window.innerWidth;
          me.windowHeigth = window.innerHeight;
          me.obtenerTotalPresupuesto();
          me.obtenerTotalPresupuestoPorMes(me.searchMesValue);
          
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    duplicarItem() {
      let me = this;
      me.loader=true;
      //creamos el objeto que se va a enviar

      axios
        .post("api/seguimiento_lineas/Duplicar", me.itemPresupuestoLinea.id_presupuesto_linea )
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogDuplicar = false;
          me.loader=false;
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogDuplicar = false;
          me.loader=false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    duplicarItems() {
      let me = this;
      let idsSeleccionados = this.selectLineaPresupuesto.map(item => item.id_presupuesto_linea);
      me.loader=true;
      axios
        .post("api/seguimiento_lineas/DuplicarVarios" , idsSeleccionados )
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogDuplicar = false;
          me.selectLineaPresupuesto = [];
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
          me.loader=false;
        })
        
        .catch(function (error) {
          me.dialogDuplicar = false;
          me.loader=false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    obtenerTotalPresupuesto() {
      console.log("obtenerTotalPresupuesto",this.id_presupuesto,this.codigoSac);
      let me = this;
      axios
        .get("api/seguimiento_lineas/ObtenerTotalPresupuesto/" + me.id_presupuesto+"/"+ me.codigoSac+"/0")
        .then(function (response) {
          console.log("response",response);
          me.totalPresupuesto = response.data.total;
         
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtenerTotalPresupuestoPorMes(mes) {
      console.log("obtenerTotalPresupuestoPorMes",this.id_presupuesto,this.codigoSac,mes);
      let me = this;
      if (mes == null || mes == undefined || mes == "" || isNaN(mes)) {
        mes = 0;         
      }
      console.log("sigo aqui");
      axios
        .get("api/seguimiento_lineas/ObtenerTotalPresupuesto/" + me.id_presupuesto+"/"+ me.codigoSac+"/"+mes)
        .then(function (response) {
          console.log("sigo aqui2");
          me.totalPresupuestoMes = response.data.total;
         
        })
        .catch(function (error) {
          console.log("auch");
          console.log(error);
        });
    },
    listarVista() {
      let me = this;
      axios
        .get("api/presupuesto_lineas/listarVista/" + me.id_presupuesto)
        .then(function (response) {
          me.vistas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectPresupuesto() {
      let me = this;
      console.log(me.usuario);
      axios
        .get("api/presupuestos/select")
        .then(function (response) {
          me.presupuestos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectCuentasContables() {
      let me = this;

      axios
        .get(
          "api/cuenta_contables/SelectTipoPresupuesto/" + me.tipo_presupuesto + "/"+ me.usuario
        )
        .then(function (response) {
          me.cuentasContables = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectNits() {
      let me = this;
      axios
        .get("api/nits/select")
        .then(function (response) {
          me.nitsServicio = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCentroCostos() {
      let me = this;
      axios
        .get("api/centro_costos/select")
        .then(function (response) {
          me.centroCostos = response.data;
          
          
          
          let cc = me.centroCostos.find(s => s.descripcion === "MKETING");
          if (cc) {
            me.id_centro_costo = cc.id;
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectServicio() {
      let me = this;
      axios
        .get("api/servicios/select")
        .then(function (response) {
          me.servicios = response.data;
        
        let servicio = me.servicios.find(s => s.descripcion === "OTRO");
          console.log("servicio",servicio);
        if (servicio) {
          me.id_servicio = servicio.id;
        }

          
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectFamilia() {
      let me = this;
      if(this.$roles.hasRole('ADM') || this.$roles.hasRole('COM') || this.$roles.hasRole('JEF')){
        axios
        .get("api/familias/select")
        .then(function (response) {
          me.familias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });

      }else{
        axios
        .get("api/familias/SelectPorGDP/" + me.codigoSac)
        .then(function (response) {
          me.familias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });

      }


      
    },
    selectAprobacion() {
      let me = this;
      axios
        .get("api/tipo_aprobaciones/select")
        .then(function (response) {
          me.tipoAprobaciones = response.data;

        let tipo = me.tipoAprobaciones.find(s => s.descripcion === "OTRO");
        console.log("tipo",tipo);
        if (tipo) {
          me.id_tipo_aprobacion = tipo.id;
        }


        })
        .catch(function (error) {
          console.log(error);
        });
    },

    abrirAgregarServicio() {
      this.dialogAgregarServicio = true;
      this.codigoServicio = this.nuevoServicio;
      /*this.$nextTick(() => {
        this.$refs["codigo"].focus();
      });*/
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },
    mostrarDialogReplicar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      } else {
        this.dialogReplicar = true;
      }
    },

    mostrarDialogReemplazar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      } else {
        this.dialogReemplazar = true;
      }
    },

    mostrarDialogBorrar(item) {
      this.dialogBorrar = true;
      if(!this.multiple){
        this.id = item.id;
      }
    },
    mostrarDialogDuplicar(item) {
      this.itemPresupuestoLinea = item;
      this.dialogDuplicar = true;
      if(!this.multiple){
        this.id = item.id;
    }

    },
    mostrarDialogVista() {
      this.dialogTablaVista = true;
      this.listarVista();
    },
    editItem(item) {
      
      this.id = item.id;
      this.id_cuenta_contable = item.id_cuenta_contable;
      this.id_centro_costo = item.id_centro_costo;
      this.tipo_presupuesto = item.tipo_presupuesto;
      this.mes = item.mes;
      this.detalle = item.detalle;
      this.monto = item.monto;
      this.id_servicio = item.id_servicio;
      this.detalle = item.detalle;
      this.id_familia = [item.id_familia];
      this.id_tipo_aprobacion = item.id_tipo_aprobacion;

      this.editedIndex = true;
      this.editCodigo = false;
      this.dialog = true;
    },
    addItem() {
      this.editCodigo = true;
     
          let cc = this.centroCostos.find(s => s.descripcion === "MKETING");
          if (cc) {
            this.id_centro_costo = cc.id;
          }


      let servicio = this.servicios.find(s => s.descripcion === "OTRO");

        if (servicio) {
          this.id_servicio = servicio.id;
        }

        let tipo = this.tipoAprobaciones.find(s => s.descripcion === "OTRO");
        
        if (tipo) {
          this.id_tipo_aprobacion = tipo.id;
        }
      
      this.dialog = true;
      
    },


    

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.id_cuenta_contable = "";
      this.id_centro_costo = "";
      this.tipo_presupuesto = "COM";
      this.mes = [];
      this.monto = "0";
      this.id_servicio = "";
      this.detalle = "";
      this.id_familia = [];
      this.id_tipo_aprobacion = "";
      this.mensajeError = false;
      this.error = "";
      this.snackbar = false;
      this.validaMensaje = [];
      this.editedIndex = false;
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    limpiarServicio() {
      this.codigoServicio = "";
      this.descripcionServicio = "";
      this.id_nitServicio = "";
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      var mesString = this.mes;
      var famString = this.id_familia[0];

      if (this.editedIndex == true) {
        //codigo para editar
        let me = this;
        axios
          .put("api/seguimiento_lineas/ActualizarCom", {
            id: me.id,
            id_presupuesto: me.id_presupuesto,
            id_cuenta_contable: me.id_cuenta_contable,
            id_centro_costo: me.id_centro_costo,
            tipo_presupuesto: me.tipo_presupuesto,
            mes: mesString,
            monto: me.monto,
            id_servicio: me.id_servicio,
            detalle: me.detalle,
            id_familia: famString,
            id_tipo_aprobacion: me.id_tipo_aprobacion,
            EditedBy: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
        //codigo para guardar
        let me = this;
        axios
          .post("api/presupuesto_lineas/CrearCom", {
            codigo: me.codigo,
            id_presupuesto: me.id_presupuesto,
            id_cuenta_contable: me.id_cuenta_contable,
            id_centro_costo: me.id_centro_costo,
            tipo_presupuesto: me.tipo_presupuesto,
            mes: me.mes,
            monto: me.monto,
            id_servicio: me.id_servicio,
            detalle: me.detalle,
            id_familia: me.id_familia,
            id_tipo_aprobacion: me.id_tipo_aprobacion,
            EditedBy: me.usuario,
            InsertedBy: me.codigoSac,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarServicio() {
      if (this.validarServicio() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      let me = this;
      axios
        .post("api/servicios/crear", {
          codigo: me.codigoServicio,
          descripcion: me.descripcionServicio,
          id_nit: me.id_nitServicio,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.closeServicio();
          me.selectServicio();
          me.$store.dispatch("setSnackbar", {
            text: " Servicio creado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    guardarReemplazar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      let me = this;
      axios
        .post("api/presupuesto_lineas/CrearComBorrarDuplicados", {
          codigo: me.codigo,
          id_presupuesto: me.id_presupuesto,
          id_cuenta_contable: me.id_cuenta_contable,
          id_centro_costo: me.id_centro_costo,
          tipo_presupuesto: me.tipo_presupuesto,
          mes: me.mes,
          monto: me.monto,
          id_servicio: me.id_servicio,
          detalle: me.detalle,
          id_familia: me.id_familia,
          id_tipo_aprobacion: me.id_tipo_aprobacion,
          EditedBy: me.usuario,
          InsertedBy: me.usuario,
        })
        .then(function (response) {
          me.dialogReemplazar = false;
          me.mensajeError = false;
          me.close();
          me.listar();
          me.limpiar();
          me.$store.dispatch("setSnackbar", {
            text: " Los registros fueron guardados exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    validarDuplicados() {
      /*let me = this;
      if (this.editedIndex == false) {
        axios
          .post("api/presupuesto_lineas/validarDuplicadosCom", {
            codigo: me.codigo,
            id_presupuesto: me.id_presupuesto,
            id_cuenta_contable: me.id_cuenta_contable,
            id_centro_costo: me.id_centro_costo,
            tipo_presupuesto: me.tipo_presupuesto,
            mes: me.mes,
            monto: me.monto,
            id_servicio: me.id_servicio,
            detalle: me.detalle,
            id_familia: me.id_familia,
            id_tipo_aprobacion: me.id_tipo_aprobacion,
          })
          .then(function (response) {
            if (response.data == "") {
              me.mensajeError = false;
            } else {
              me.mensajeError = true;
              me.error = response.data;
            }
            me.windowWidth = window.innerWidth;
            me.windowHeigth = window.innerHeight;
          })
          .catch(function (error) {
            console.log("Error");
          });
      }*/
    },

    validar() {
      this.valida = 0;
      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
    validarServicio() {
      this.valida = 0;
      Object.keys(this.formServicio).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/presupuesto_lineas/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    borrarItem() {
      let me = this;
      axios
        .put("api/presupuesto_lineas/Eliminar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogBorrar = false;
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogBorrar = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    borrarItems() {
      
      let me = this;
      axios
        .put("api/presupuesto_lineas/EliminarVarios", this.selectLineaPresupuesto)
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogBorrar = false;
          me.selectLineaPresupuesto = [];
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogBorrar = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    
    
    //Devuelve un entero entre 1 y 12 convertido a mes en letras, si mayus=true -> se devuelven mayúsculas
    enteroaMeses(numeroMes, mayus) {
      var meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      var mesLetras = "";

      if (!isNaN(numeroMes) && numeroMes >= 1 && numeroMes <= 12) {
        mayus
          ? (mesLetras = meses[numeroMes - 1].toUpperCase())
          : (mesLetras = meses[numeroMes - 1]);
      }
      return mesLetras;
    },

    filtroCuenta(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCuentaValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCuentaValue.toLowerCase());
    },
    filtroMes(value) {
      var val = value.toString();
      var a = true;
      // If this filter has no value we just skip the entire filter.
      if (!this.searchMesValue) {
        return true;
      }
      
      //verificar si el mes completo se corresponde a la búsqueda
      value == this.searchMesValue ? (a = true) : (a = false);
      return a;
    },
  },
};
</script>
